import React from "react";
import {
  BarChart,
  XAxis,
  YAxis,
  Bar,
  Cell,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import Loader from "../../components/Common/Loader";
function AvgLife({ List, loadingdata }) {
  const today = new Date();
  const clientLifetimes = List.map((client) => {
    const startDate = new Date(client.startDate);
    const endDate = client.endDate ? new Date(client.endDate) : today;
    const lifetime = (endDate - startDate) / (1000 * 60 * 60 * 24);
    return { ...client, lifetime };
  }).filter((client) => client.lifetime > 30);

  const totalLifetime = clientLifetimes.reduce(
    (sum, client) => sum + client.lifetime,
    0
  );
  const averageLifetime = clientLifetimes.length
    ? (totalLifetime / clientLifetimes.length).toFixed(1)
    : 0;

  if (loadingdata) return <Loader />;
  return (
    <div className=" ">
      <div className="total-clients-container-avg ">
        <div className="website-hits-header">
          {/* Title Section */}
          <div className="website-hits-title">
            <h1>Client per team member</h1>
          </div>

          {/* Total Hits Section */}
          <div className="website-hits-total">
            <h1>Average lifetime</h1>
            <p className="total-hits-count">{averageLifetime} month</p>
          </div>
        </div>

        <div className="chart-container-avg">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={List} layout="vertical">
              <XAxis type="number" />
              <YAxis dataKey="name" type="category" />
              <Bar dataKey="value" fill="#A42066" radius={[0, 12, 12, 0]}>
                {List.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill="#A42066" />
                ))}
                <LabelList
                  dataKey="value"
                  position="insideRight"
                  fill="#FFFFFF"
                />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}

export default AvgLife;
